import React from 'react';
import styled from 'styled-components';

const HeroStyle = styled.div`
	background-image: url(${(p) => p.src});
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 29rem;

	.text-container {
		text-align: center;
		color: #fff;

		h1 {
			padding: 0 2rem;
		}
		.toptext {
			margin-bottom: 0.5rem;
		}

		@media all and (max-width: 550px) {
			h1 {
				font-size: 2.5rem;
				line-height: 3rem;
			}
		}
	}
`;
export default ({ title, src, logo }) => {
	return (
		<HeroStyle className="hero" src={src}>
			<img src={logo} alt={title} />
		</HeroStyle>
	);
};
